
let localCertsIDBStore = null;
const getLocalCertsIDBStore = () => {
  if (localCertsIDBStore) return localCertsIDBStore;
  return localCertsIDBStore=new window.UIExtension.PDFViewCtrl.shared.IndexDBStore('LocalCertificates', 'LocalCertificates', 1, 'serial');
}

/**
 * Get all.
 * @returns {Promise}
 */
export const getDigitalIDs = () => {
  return getLocalCertsIDBStore().getAll();
};

/**
 * Add or replace.
 * @param info
 * @returns {Promise}
 */
export const setDigitalID = (info) => {
  return getLocalCertsIDBStore().add(info);
};

/**
 * Remove.
 * @param serial
 * @returns {Promise}
 */
export const removeDigitalID = (serial) => {
  return getLocalCertsIDBStore().remove(serial);
}

export const getDigitalIDBySerial = (serial) => {
  return getLocalCertsIDBStore().get(serial);
}

export const isEmail = (str) => {
  return /^\w+(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/.test(str);
}

export const adjustUI4Table = (theadRef, tbodyRef) => {
  const theadDom = theadRef.current;
  const tbodyDom = tbodyRef.current;
  if (theadDom && tbodyDom) {
    const scrollWidth = tbodyDom.offsetWidth - tbodyDom.clientWidth;
    const trArr = theadDom.getElementsByClassName('tr');
    if(trArr.length){
      for(const item of trArr){
        item.style.paddingRight = `${scrollWidth}px`;
      }
    }
  }
}